<div oui-dialog-title>
    Transmission courrier
    <oui-button type="icon" oui-dialog-close>
      <oui-icon>close</oui-icon>
    </oui-button>
  </div>
  
  <oui-dialog-content>
    En cliquant sur "Valider", l'opération sera en attente d'un bordereau. Vous ne pourrez plus revenir en arrière.
  </oui-dialog-content>
  
  <oui-dialog-actions>
    <oui-button type="text" oui-dialog-close>Annuler</oui-button>
    <oui-button type="contained" [oui-dialog-close]="true">Valider</oui-button>
  </oui-dialog-actions>
  